import { YhBox } from "@/erp_subpackage/components/YhBox";
import React from "react";
import { useTranslation } from 'react-i18next';
import { DataTable } from "./DataTable";

export const DataBox = () => {
    const { t } = useTranslation();
    return (
        <YhBox title= {t(`paper.view.DataBox.记录列表`)}>
            <DataTable />
        </YhBox>
    )
}

